import { clsx } from "clsx"
import { useHistory, useLocation } from "react-router-dom"
import { RegisterType } from "src/pages/auth/types"
import "./style.scss"

interface Props {
  type: RegisterType
}
export const RegisterTypeTab = ({ type }: Props) => {
  const { search } = useLocation()
  const history = useHistory()
  const isCorporate = type === RegisterType.Corporate
  const navigate = (type: RegisterType) => {
    history.push(`/register/${type}${search ?? ""}`)
  }
  // useEffect(() => {
  //   if (type == null) navigate(RegisterType.Personal)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [type, search, history])
  return (
    <div className="wrapper">
      <div className="register-type">
        <div
          className={clsx("register-type__item", {
            active: !isCorporate,
          })}
          onClick={() => navigate(RegisterType.Personal)}
        >
          Personal
        </div>
        <div
          className={clsx("register-type__item", {
            active: isCorporate,
          })}
          onClick={() => navigate(RegisterType.Corporate)}
        >
          Corporate
        </div>
      </div>
    </div>
  )
}
